"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getConfigVal = exports.EnvType = void 0;
if (typeof window !== "undefined") {
    window.env = window.env || {};
}
var EnvType;
(function (EnvType) {
    EnvType[EnvType["String"] = 0] = "String";
    EnvType[EnvType["Float"] = 1] = "Float";
    EnvType[EnvType["Integer"] = 2] = "Integer";
    EnvType[EnvType["Boolean"] = 3] = "Boolean";
})(EnvType = exports.EnvType || (exports.EnvType = {}));
function getConfigVal(key, type, def) {
    // some gymnastics to enable omission of type with fallback specified
    def = typeof type === "string" ? type : def;
    type = typeof type === "string" ? EnvType.String : type || EnvType.String;
    const val = process.env["EARNUP_APP_" + key] ||
        (typeof window !== "undefined" && window.env["EARNUP_APP_" + key]) ||
        process.env["REACT_APP_" + key] ||
        def;
    if (process.env.NODE_ENV === "development" &&
        !process.env.EARNUP_APP_OVERRIDE_STRICT_ENV_CHECK &&
        !val &&
        !def) {
        throw Error(`Missing ENV variable with no default: EARNUP_APP_${key}`);
    }
    if (process.env.NODE_ENV === "development" &&
        !val &&
        process.env.EARNUP_APP_STRICT_ENV_CHECK) {
        throw Error(`STRICT_ENV_CHECK: Missing ENV variable with no default: EARNUP_APP_${key}`);
    }
    if (type === EnvType.String) {
        return val;
    }
    else if (type === EnvType.Integer) {
        const ret = parseInt(val, 10);
        if (isNaN(ret)) {
            console.warn(`Warning: var EARNUP_APP_${key} cannot be parsed as an Integer`);
        }
        return ret || undefined;
    }
    else if (type === EnvType.Float) {
        const ret = parseFloat(val);
        if (isNaN(ret)) {
            console.warn(`Warning: var EARNUP_APP_${key} cannot be parsed as a Float`);
        }
        return ret || undefined;
    }
    else if (type === EnvType.Boolean) {
        return (val === "true");
    }
    else {
        return undefined;
    }
}
exports.getConfigVal = getConfigVal;
